module.exports = __webpack_public_path__ + "static/img/home_h122px_applets_icon_tap.fdabf8f.gif";


//////////////////
// WEBPACK FOOTER
// ./static/images/home_h122px_applets_icon_tap.gif
// module id = I0D5
// module chunks = 0